﻿import React, {FC} from 'react';
import {FormControlProps} from "@mui/material";
import {SearchFilterFormControl} from './styles'

const SearchFilterAndSortFormControl: FC<FormControlProps> = ({children, ...rest}) => {
  return <SearchFilterFormControl variant='standard' size='small' {...rest}>
    {children}
  </SearchFilterFormControl>
}

export default SearchFilterAndSortFormControl;
